import type React from 'react';

import { ProgressStepper, Separator, Text } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import { ShareActions } from '../../../ShareActions';
import { ShareFeed } from '../../../ShareFeed';

import { useReachGoalStep } from './hooks/useReachGoalStep';

type ReachGoalStepProps = {
	goalValue: number;
};

export const ReachGoalStep: React.FC<ReachGoalStepProps> = ({ goalValue }) => {
	const { translate, translatePlural } = useI18n();
	const {
		data: { userName, shareFeed },
	} = useReachGoalStep();

	const goalLabel = translatePlural('corgi.psf.share.sharing_goal.goal_signs', goalValue, { count: goalValue });

	return (
		<>
			<div className="flex flex-col gap-7 px-6 md:gap-9 md:px-10">
				<div className="flex flex-col items-center gap-2.5 px-6">
					<Text className="text-typography-strong text-center">
						{translate('corgi.psf.share.sharing_goal.reach_goal_title')}
					</Text>
					<ProgressStepper currentStepNumber={3} numberOfSteps={3} />
				</div>

				<div className="flex flex-col gap-3 md:gap-4">
					<Text size="xx-small" variant="heading" as="p" className="text-typography-weak m-0">
						{translate('corgi.psf.share.sharing_goal.reach_goal_greeting', { user_name: userName })}
					</Text>
					<Text size="small" variant="heading" as="h1" className="text-typography-strong m-0">
						{translate('corgi.psf.share.sharing_goal.reach_goal_label', { goal_label: goalLabel })}
					</Text>
					<Text variant="body" className="text-typography-strong">
						{translate('corgi.psf.share.sharing_goal.reach_goal_body')}
					</Text>
				</div>

				<ShareActions />

				{shareFeed.showFeed && <Separator className="m-0" />}
			</div>

			{shareFeed.showFeed && (
				<div className="relative mt-7 h-full overflow-hidden md:mt-9" data-qa="share-feed">
					<ShareFeed items={shareFeed.items} />
				</div>
			)}
		</>
	);
};
